import React from 'react';
import { DESKTOP, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { useSelector } from 'src/client/redux';
import styled from 'styled-components/macro';
import { useStaticSplashContent } from './content/useStaticSplashContent';

export const Awards = () => {
  const { awards } = useStaticSplashContent();
  const { cdnUrl } = useSelector((state) => state.app);
  const site = useSelector((state) => state.site);

  if (!awards.length) {
    return null;
  }

  return (
    <Wrapper>
      {awards.map((award) => (
        <Award key={award} src={`${cdnUrl}/awards/${site.UUID}/${award}.svg`} alt={`${award} award`} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  grid-area: awards;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  gap: 10px;
  justify-items: center;
  padding: 0 5px;
  width: 100%;
  margin: 0 auto 30px;
  max-width: 1300px;

  @media ${TABLET_PORTRAIT} {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: 1fr;
    margin-left: auto;
    margin-right: auto;
    padding: 0 30px;
  }

  @media ${DESKTOP} {
    padding: 0 60px;
  }
`;

const Award = styled.img`
  width: 100%;
`;
